import { noop } from 'lodash';

import { DropdownItem } from 'reactstrap';
import styled from 'styled-components';
import CheckIcon from '../icons/CheckIcon';
import IconContainer from './IconContainer';

// header is smaller and to the left of a regular dropdown item
const DropdownHeader = styled(DropdownItem)`
  font-size: 0.8rem;
  margin-left: -8px;
`;

const DropdownItemOption = styled(DropdownItem)`
  display: flex;
  align-items: center;
`;

const DropdownOption = ({
  option,
  setOption = noop,
  selectedOption,
  onClickOverride,
  showCheckmark = false,
}) => {
  if (option.divider) {
    return <DropdownItem divider />;
  }
  if (option.header) {
    return <DropdownHeader header>{option.name}</DropdownHeader>;
  }

  const defaultOnClick = () => setOption(option);

  const toggle = typeof option.toggle === 'undefined' ? true : option.toggle;

  return (
    <DropdownItemOption
      onClick={onClickOverride || defaultOnClick}
      disabled={option.disabled}
      toggle={toggle}
      style={{ pointerEvents: option.disabled ? 'none' : 'auto' }}
      className={option.icon || showCheckmark ? 'px-3' : ''}
    >
      <span
        className={`d-flex flex-row align-items-center ${
          option.name === selectedOption ? 'font-weight-bold' : ''
        } ${option.icon ? 'justify-content-start' : ''}`}
      >
        {showCheckmark && (
          <IconContainer className="mr-2">
            {option.name === selectedOption ? <CheckIcon /> : null}
          </IconContainer>
        )}
        {option.icon && (
          <IconContainer iconSize="18px" className="mr-2">
            {option.icon}
          </IconContainer>
        )}
        {option.name}
      </span>
    </DropdownItemOption>
  );
};

export default DropdownOption;
